var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-tel-input-vuetify", {
    attrs: {
      required: _vm.required,
      label: _vm.label,
      "preferred-countries": ["VE"],
      "default-country": "ve",
      readonly: _vm.readonly,
      placeholder: "",
      hint: "0212-1111111 o 0412-2222222",
      rules: [
        function(v) {
          return !!v || "Requerido"
        },
        function(v) {
          return _vm.phoneStatus.valid || "Teléfono inválido"
        }
      ],
      disabled: _vm.disabled
    },
    on: { input: _vm.phoneChanged },
    model: {
      value: _vm.phone,
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }